/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Storage from '../../../../utils/storage/storage';
import fetchUserMetadata, { fetchScreensMetadata } from '../api/user-api';
import { IUserMetadata } from '../types/user-meta-model';

export const getUserMetadata = createAsyncThunk('getUserMetadata', async () => {
  const userMetadata = await fetchUserMetadata();
  const screenInfo = await fetchScreensMetadata();
  return {
    userMeta: userMetadata.data[0],
    screenMeta: screenInfo.data.results
  };
});

const initialState: IUserMetadata = {
  source: null,
  source_name: 'Pricing Simulator',
  user: null,
  user_name: 'dummy',
  user_email: '',
  role: [],
  usertype: [],
  screenInfo: [],
  fetchingMetadata: false
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUserMetadata(state) {
      const { userMeta, screenMeta } = Storage.getUserMetadata();
      if (userMeta) {
        state.source = userMeta.source;
        state.role = userMeta.role;
        state.source_name = userMeta.source_name;
        state.user = userMeta.user;
        state.usertype = userMeta.usertype;
        state.user_name = userMeta.user_name;
        state.user_email = userMeta.user_email;
        state.screenInfo = screenMeta;
      }
    },
    setSourceId(state, action) {
      const { userMeta } = Storage.getUserMetadata();
      // setting source id in localStorage and in slice
      if (userMeta) {
        state.source = action.payload;
        Storage.setSourceId(action.payload);
      }
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getUserMetadata.fulfilled, (state, action) => {
        state.fetchingMetadata = false;
        const { userMeta, screenMeta } = action.payload;
        state.source = userMeta.source;
        state.role = userMeta.role;
        state.source_name = userMeta.source_name;
        state.user = userMeta.user;
        state.usertype = userMeta.usertype;
        state.user_name = userMeta.user_name;
        state.user_email = userMeta.user_email;
        state.screenInfo = screenMeta;
        Storage.setUserMetadata({ userMeta, screenMeta });
      })
      .addCase(getUserMetadata.pending, (state) => {
        state.fetchingMetadata = true;
      })
      .addCase(getUserMetadata.rejected, (state) => {
        state.fetchingMetadata = false;
      })
});

export const { updateUserMetadata, setSourceId } = userSlice.actions;

export default userSlice;
